module.exports = __webpack_public_path__ + "img/-1 (1).b8e80981.jpg";